import { render } from "./SevenDaysRecord.vue?vue&type=template&id=4ca5bfc1&scoped=true"
import script from "./SevenDaysRecord.vue?vue&type=script&lang=js"
export * from "./SevenDaysRecord.vue?vue&type=script&lang=js"

import "./SevenDaysRecord.vue?vue&type=style&index=0&id=4ca5bfc1&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4ca5bfc1"

export default script